import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import Modal from './Modal';

const pages = [
    ['/blog', 'Blog'], ['/stories', 'Příběhy'], ['/videa', 'Videa'], ['/letni-vyzva', 'Letní výzva'], ['/galerie', 'Galerie'],
];
export default function Navbar() {
    const [open, setOpen] = useState(false);
    const links = <>
        <a href="/#elements">Autorská sestava</a>
        <a href="/#schedule">Lekce a ceník</a>
        {pages.map(([to, text]) => <NavLink key={to} to={to}>{text}</NavLink>)}
        <a href="/#contact">Kontakt</a>
    </>;
    return <>
        <a className="skip-link" href="#main-content">Přejít na obsah</a>
        <header className="site-header">
            <nav className="site-nav" aria-label="Hlavní navigace">
                <Link to="/" className="brand" aria-label="Qigong – úvodní stránka">
                    <span>Qigong<small>Tomáš Číhal · Plzeň</small></span>
                </Link>
                <div className="desktop-navigation">{links}</div>
                <a href="/#schedule" className="button button-primary nav-cta">Začít cvičit <span aria-hidden="true">↗</span></a>
                <button type="button" className="menu-toggle" aria-label="Otevřít menu" aria-expanded={open}
                    aria-controls={open ? 'mobile-navigation' : undefined} onClick={() => setOpen(true)}>
                    <span aria-hidden="true">☰</span><span>Menu</span>
                </button>
            </nav>
        </header>
        {open && <Modal label="Navigace" className="navigation-dialog" onClose={() => setOpen(false)}>
            <p className="eyebrow">Cesta mého vnitřního Já</p>
            <nav id="mobile-navigation" className="mobile-navigation" aria-label="Mobilní navigace" onClick={e => {
                if (e.target.closest('a')) setOpen(false);
            }}>{links}<a href="/rules">Pravidla studia</a><a href="/panel">Přihlášení na lekce</a></nav>
            <a href="tel:+420734327357" className="button button-primary">Zavolat Tomášovi</a>
        </Modal>}
    </>;
}
